import { obterUsuarioLogadoLocal } from '../usuario-service';

export const getAuthorities = (filterAuthorities = [], authority) => {
  const usuarioLogado = obterUsuarioLogadoLocal();
  const authorities =
    usuarioLogado && usuarioLogado.authorities ? usuarioLogado.authorities : [];

  let filteredAuthorities = authorities;

  if (filterAuthorities && filterAuthorities.length > 0) {
    filteredAuthorities = authorities.filter((a) =>
      filterAuthorities.includes(a.authority)
    );
  }

  const hasAuthority = authority
    ? authorities.some((a) => a.authority === authority)
    : false;

  return {
    authorities: filteredAuthorities,
    hasAuthority,
  };
};
